import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useLanguage } from '../lib/LanguageContext';
import translations from '../lib/translations';
import './Header.css';

/* Inline SVG flag icons — render identically on all platforms */
function FlagFR({ size = 20 }) {
  return (
    <svg width={size} height={Math.round(size * 0.667)} viewBox="0 0 30 20" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius: 2, display: 'block', flexShrink: 0 }}>
      <rect width="10" height="20" fill="#002395" />
      <rect x="10" width="10" height="20" fill="#EDEDED" />
      <rect x="20" width="10" height="20" fill="#ED2939" />
    </svg>
  );
}

function FlagGB({ size = 20 }) {
  const h = Math.round(size * 0.5);
  return (
    <svg width={size} height={h} viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius: 2, display: 'block', flexShrink: 0 }}>
      <rect width="60" height="30" fill="#012169" />
      {/* White diagonals */}
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
      {/* Red diagonals */}
      <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
      {/* White cross */}
      <rect x="24" width="12" height="30" fill="#fff" />
      <rect y="12" width="60" height="6" fill="#fff" />
      {/* Red cross */}
      <rect x="26" width="8" height="30" fill="#C8102E" />
      <rect y="13" width="60" height="4" fill="#C8102E" />
    </svg>
  );
}

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const FlagIcon = t.langCode === 'fr' ? FlagFR : FlagGB;

  return (
    <header className="header">
      <div className="header-inner">
        <Link to="/" className="logo" onClick={closeMenu}>
          <img src="/logo.svg" alt="MegaTransact" className="logo-img" />
        </Link>

        <button
          className="lang-toggle lang-toggle-mobile"
          onClick={toggleLanguage}
          aria-label={t.langLabel}
          title={t.langLabel}
        >
          <FlagIcon size={20} />
          <span className="lang-toggle-text">{t.langToggle}</span>
        </button>

        <button
          className={`menu-toggle${menuOpen ? ' open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle navigation"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <nav
          className={`header-nav${menuOpen ? ' nav-open' : ''}`}
          aria-label="Primary navigation"
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            {t.nav.home}
          </NavLink>
          <NavLink
            to="/terms-and-conditions"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            {t.nav.terms}
          </NavLink>
          <NavLink
            to="/privacy-policy"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            {t.nav.privacy}
          </NavLink>
          <NavLink
            to="/lending-terms"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            {t.nav.lending}
          </NavLink>
          <NavLink
            to="/responsible-use"
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={closeMenu}
          >
            {t.nav.responsible}
          </NavLink>

          <button
            className="lang-toggle"
            onClick={() => { toggleLanguage(); closeMenu(); }}
            aria-label={t.langLabel}
            title={t.langLabel}
          >
            <FlagIcon size={20} />
            <span className="lang-toggle-text">{t.langToggle}</span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
